import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Shows warning snackbars for a list of messages.
 * Empty/blank entries are ignored; each message is shown with a small stagger delay.
 */
export function showWarningSnackbars(
  snackBar: MatSnackBar,
  warnings: string[] | undefined,
  durationMs: number,
  initialDelayMs = 0,
  staggerDelayMs = 300
): void {
  const messages = (warnings ?? []).map((x) => x?.trim()).filter((x): x is string => !!x);
  messages.forEach((message, index) => {
    setTimeout(
      () => {
        snackBar.open(message, undefined, {
          panelClass: 'error',
          duration: durationMs
        });
      },
      initialDelayMs + index * staggerDelayMs
    );
  });
}
